export default __webpack_public_path__ + "static/media/slate.6e1642d7.png";